import React from 'react';
import { connect } from 'react-redux';

const mapStateToProps = (state) => {
	const {
		answerCount,
		rightFeedbackProps,
		leftFeedbackProps,
	} = state.rootReducer.testPageDetails;

	return {
		answerCount,
		rightFeedbackProps,
		leftFeedbackProps,
	};
};

const WordCloudCorrectFeedback = ({
	rightFeedbackProps: { textCorrectAnswer, correctAnswer },
}) => {
	textCorrectAnswer = !!textCorrectAnswer ? textCorrectAnswer : correctAnswer;

	return (
		<span>
			<h4 className="text-success">That's Correct</h4>
			<div className="quiz-area-answer">
				<div className="display-flex align-center">
					<div className="bord-right col-md-3">
						<h4 className="text-success text-right">Your answer</h4>
					</div>
					<p className="pad-all mar-no">{correctAnswer}</p>
				</div>
			</div>
		</span>
	);
};

export default connect(mapStateToProps)(WordCloudCorrectFeedback);
